import React from "react";
import { Plus, Trash2, AlertCircle, Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { StepCard, GeneratePeriods } from "./_helpers";
import { totalPeriodPercent } from "@/lib/grading";

/** Step 1 — Grading Periods (terms / quarters). */
export default function Step1Periods({
  periods, gradingMode,
  onGenerate, onAdd, onUpdate, onDelete,
}) {
  const total = totalPeriodPercent(periods);
  const isOk = gradingMode !== "calculated" || periods.length === 0 || total === 100;
  const badge = gradingMode === "calculated" && periods.length > 0 ? (
    <span className={`inline-flex items-center gap-1 text-xs font-heading font-bold px-2.5 py-1 rounded-full ${isOk ? "bg-[#E8F5E9] text-[#2E7D32]" : "bg-[#FDECEA] text-[#C62828]"}`}>
      {isOk ? <Check className="w-3 h-3" /> : <AlertCircle className="w-3 h-3" />}
      Total: {total}%
    </span>
  ) : null;

  return (
    <StepCard step="Step 1" title="Grading Periods / Terms"
      subtitle="Generate the grading term rows. You can rename and adjust percentages after."
      testId="step-1" badge={badge}
    >
      <GeneratePeriods onGenerate={onGenerate} />
      {periods.length > 0 && (
        <div className="mt-3 space-y-2">
          {periods.map((p, i) => (
            <div key={p.id} className="grid grid-cols-12 gap-2 items-center" data-testid={`gs-period-${p.id}`}>
              <span className="col-span-1 text-xs text-brand-inkMuted tabular-nums text-center">#{i + 1}</span>
              <Input value={p.period_name} onChange={(e) => onUpdate(p.id, { period_name: e.target.value })}
                placeholder="Period name" className="col-span-7 rounded-xl h-10" />
              <Input type="number" value={p.period_percentage} onChange={(e) => onUpdate(p.id, { period_percentage: Number(e.target.value) })}
                placeholder="%" className="col-span-3 rounded-xl h-10" />
              <Button size="icon" variant="ghost" onClick={() => onDelete(p.id)} className="col-span-1 text-[#C62828]" data-testid={`gs-del-period-${p.id}`}>
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
          <Button size="sm" variant="outline" onClick={onAdd} className="rounded-xl mt-2" data-testid="gs-add-period">
            <Plus className="w-3.5 h-3.5 mr-1" /> Add Period
          </Button>
        </div>
      )}
    </StepCard>
  );
}
